export function getDXPEnvironmentRootPath() {
  return import.meta.env.VITE_PROXY_DXP_ENABLE === 'true'
    ? import.meta.env.VITE_API_URL_DXP_PROXY
    : import.meta.env.VITE_API_URL_DXP
}

export function getDXPMockEnvironmentRootPath() {
  return import.meta.env.VITE_API_URL_DXP_MOCK
}

export function getMDEnvironmentRootPath() {
  return import.meta.env.VITE_PROXY_MD_ENABLE === 'true'
    ? import.meta.env.VITE_API_URL_MIDDLEWARE_PROXY
    : import.meta.env.VITE_API_URL_MIDDLEWARE
}
